<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  data() {
    return {};
  },

  created() {
    // this.$http
    //   .post("/api/user/getInfo")
    //   .then((res) => {
    //     this.setLoginSuccess(res.data);
    //     this.setUserInfo(res.data);
    //   })
    //   .catch((e) => {
    //     console.error(e);
    //   });

    console.log("app created");
  },
  methods: {
    ...mapMutations(["setLoginSuccess", "setUserInfo"]),
  },
};
</script>
<style>
#app {
  margin: 0 auto;
}
</style>
